import React from "react"

interface CheckboxProps {
	props?: any
	className?: string | null
	label?: any
	errMsg?: string
	hasError?: any
	children: any
}

const ElemCheckbox: React.FC<CheckboxProps> = ({ className, label, errMsg, hasError, children }) => {
	return (
		<label className={"relative block cursor-pointer mb-4 " + (className || "")}>
			{children}
			<img src={process.env.PUBLIC_URL + "/images/checkbox.svg"} alt={"not selected"} loading="lazy" className="peer-checked:hidden block absolute w-[30px] mr-[30px]" />
			<img src={process.env.PUBLIC_URL + "/images/checkbox-checked.svg"} alt={"selected"} loading="lazy" className="peer-checked:block hidden absolute w-[30px] mr-[30px]" />
			<div className="pl-[40px] font-AmsiRegular text-blue text-[16px] sm:text-[19px] peer-focus-visible:border">{label}</div>
			{hasError && <div className="formErrorMsg js-formerror mb-4 pt-2 text-[#E41D1D]">{errMsg}</div>}
		</label>
	)
}

export default ElemCheckbox
